import { useEffect, useRef, useState } from 'react';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Small } from 'foundations-components/transitional/components/Small';
import { ChatTextInput } from 'academy-common-lib/features/search/components/ChatTextInput';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { onFocusInput } from '../../magpie/academyAssistantChannel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ChatInputArea = ({
  autoFocus,
  isStreaming,
  onSend,
  onStop
}) => {
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef(undefined);
  useEffect(() => onFocusInput(() => {
    var _inputRef$current;
    return (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
  }), []);
  const submit = () => {
    if (inputValue.trim() && !isStreaming) {
      onSend(inputValue);
      setInputValue('');
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      boxShadow: "300",
      borderRadius: "400",
      children: /*#__PURE__*/_jsx(ChatTextInput, {
        autoFocus: autoFocus,
        inputRef: inputRef,
        placeholder: I18n.text('academy-ai-assistant.chat.inputPlaceholder'),
        value: inputValue,
        onChatInputChanged: e => setInputValue(e.target.value),
        onKeyDown: e => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            submit();
          }
        },
        onSend: submit,
        leadingIcon: null,
        onStop: isStreaming ? onStop : undefined
      })
    }), /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      inlineSize: "100%",
      marginBlock: "400",
      children: /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-ai-assistant.chat.disclaimer"
        })
      })
    })]
  });
};